<template>
  <div class="card">
    <cardItem :cardItem="cardMessageItem.msg" />
  </div>
</template>
<script>
import { computed } from "vue";
import cardItem from "@/components/enterprisecard/carditem.vue";

export default {
  components: { cardItem },
  props: {
    msgItem: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const cardMessageItem = computed(() => props.msgItem);

    return { cardMessageItem };
  },
};
</script>
